export * from './recorte-extracao-slice'